import {
  Table,
  TableBody,
  TableCell,
  TableCellHead,
  TableRow,
} from '~/ui/Table';
import { useNavigate } from 'react-router-dom';
import NoImageIcon from '~/assets/svg/newSvg/empty-image.svg?react';
import TableStyles from '~/ui/Table/Table.module.scss';
import styles from './AssetsTable.module.scss';
import TooltipText from '~/components/Shared/TooltipText/TooltipText';
import { useTranslation } from 'react-i18next';
import { IAsset } from '../../Assets';
import Toggle from '~/components/Shared/Toggle/Toggle';
import classNames from 'classnames';
import { getPaginate } from '~/utils/getPaginate';

interface AssetsTableProps {
  assets: IAsset[];
  isFiltered: boolean;
  assetChecked: (assetId: number, value: boolean) => void;
  setChangetAsset: (assetName: string, isEnabled: boolean) => void;
  isLoading?: boolean;
}

export const AssetsTable = ({
  assets,
  isFiltered,
  assetChecked,
  setChangetAsset,
  isLoading,
}: AssetsTableProps) => {
  const { t } = useTranslation();
  const { paginate } = getPaginate();
  const navigate = useNavigate();

  if (!assets.length && isFiltered && !isLoading) {
    return <span>{t('the_search_has_not_given_any_results')}</span>;
  }

  return (
    <div className={styles.tableWrapper}>
      <Table>
        <thead className={TableStyles.thead}>
          <tr>
            <TableCellHead sortable={false} field="">
              {''}
            </TableCellHead>
            <TableCellHead sortable={false} field="image">
              {t('logo')}
            </TableCellHead>
            <TableCellHead sortable={false} field="name">
              {t('name')}
            </TableCellHead>
            <TableCellHead sortable={false} field="description">
              {t('description')}
            </TableCellHead>
            <TableCellHead sortable={false} field="i_n_n">
              {t('tin')}
            </TableCellHead>
          </tr>
        </thead>
        <TableBody isLoading={isLoading} loadingRows={8}>
          {assets.map(({ id, name, description, inn, image_path, enabled }) => {
            const setCheckedAsset = (value: boolean) => {
              assetChecked(id, value);
              setChangetAsset(name, value);
            };

            return (
              <TableRow key={id} onClick={() => navigate(`/assets/${id}/edit${paginate ? `?paginate=${paginate}` : ''}`)}>

                <TableCell className={styles.toggleCell}>
                  <div onClick={e => e.stopPropagation()}>
                    <Toggle isChecked={enabled} onChange={setCheckedAsset} />
                  </div>
                </TableCell>
                <TableCell
                  className={classNames(styles.logoCell, styles.toggleWrapper)}
                >
                  {image_path ? (
                    <img
                      className={styles.logo}
                      src={image_path}
                      alt="Image was not loaded"
                    />
                  ) : (
                    <NoImageIcon className={styles.defaultLogo} />
                  )}
                </TableCell>
                <TableCell>{name}</TableCell>
                <TableCell className={styles.descriptionCell}>
                  <TooltipText text={description} />
                </TableCell>
                <TableCell>{inn}</TableCell>

              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default AssetsTable;
